export default {
  id: 'repair-exchange-td-archive',
  mode: {
    isModalNew: true,
    isModalPush: true
  },
  sortable: {
    field: 'poDate',
    order: 'desc'
  },
  store: {
    get: {
      url: 'RepairTearDowns/GetAllDynamic',
      selected: [
        'id',
        'rfqid',
        'rfq.poDate as poDate',
        'rfq.rfqType.Title as rfqTypeTitle',
        'rfq.customerCompany.name as companyName',
        'rfq.po',
        'part.partNumber as partNumber',
        'part.partDescription as partDescription',
        'partSN'
      ]
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        isVisible: false
      }
    }
  },
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: '(rfq.rfqType.title.contains("${data.value}") || rfq.customerCompany.name.StartsWith("${data.value}")  || rfq.po.contains("${data.value}") || part.partNumber.StartsWith("${data.value}") || partSN.contains("${data.value}") || condition.title.contains("${data.value}") ||  rfqid.contains("${data.value}") )',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'select',
        field: 'rfq.rfqTypeID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("rfq-type")}',
        options: {
          dataSource: 'RfqTypes/GetAllDynamic?select=id,title&filter=(id == 3 || id == 7 || id == 8 || id == 1 || id == 5)',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          // eslint-disable-next-line no-template-curly-in-string
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'rfq.customerCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("customer")}',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'name.StartsWith("${data.search}")',
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '25rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("part")}',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'partNumber.StartsWith("${data.search}")',
          dataSource: {
            url: 'Parts/GetAllDynamic',
            selected: 'id,partNumber',
            take: 50
          },
          option: {
            label: 'partNumber'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '10rem'
          }
        }
      }
    ]
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("po-date")}',
      field: 'poDate',
      template: 'date',
      sortable: {
        custom: 'rfq.poDate'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("rfq-type")}',
      field: 'rfqTypeTitle',
      sortable: {
        custom: 'rfq.rfqType.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("customer")}',
      field: 'companyName',
      sortable: {
        custom: 'rfq.customerCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("po")}',
      field: 'po',
      sortable: {
        custom: 'rfq.po'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("po")}',
      field: 'po',
      sortable: {
        custom: 'rfq.po'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-number')}",
      field: 'partNumber',
      sortable: {
        custom: 'part.partNumber'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-SN")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("rfqid")}',
      field: 'rfqid'
    }
  ],
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        {
          type: 'edit'
        }
      ]
    }
  }
}
